export const key = (state) => state.massMailer.key;